export const LOCALE_ES = {
    ORDER: "Pedido",
    INVOICE: "Factura",
    INVOICES: "Facturas",
    CREDIT_NOTE: "Nota de crédito",
    CREDIT_NOTES: "Notas de crédito",
    CREATION_DATE: "Fecha de creación",
    DELIVERY_DATE: "Fecha de entrega",
    DELIVERY_ADDRESS: "Dirección de entrega",
    DELIVERY_COST: "Costo de entrega",
    VENDOR: "Proveedor",
    CUSTOMER: "Cliente",
    ORDER_NUMBER: "Número de pedido",
    PAYMENT_METHOD: "Método de pago",
    NOTE: "Nota",
    PRODUCT: "Artículo",
    PRODUCT_DESCRIPTION: "Descripción",
    PRODUCT_AMOUNT: "Cantidad",
    PRODUCT_SINGLE_PRICE: "Precio unitario",
    DISCOUNT: "Descuento",
    TOTAL_DISCOUNTS: "Descuento total",
    TOTAL_BEFORE_DISCOUNTS: "Total antes de descuento",
    TAX_ABBREVIATED: "IVA",
    TAX_AMOUNT: "Monto del impuesto",
    SPLIT_AMOUNT: "Porción",
    BRUTTO: "Bruto",
    TOTAL: "Total",
    TOTAL_INCLUDING_VAT: "Total con IVA incluido",
    TOTAL_EXCLUDING_VAT: "Total sin IVA",
    VAT_ID: "NIF IVA",
    TAX_ID: "Número de identificación fiscal",
    PAID: "Pagado",
    UNPAID_AMOUNT: "Monto no pagado",
    REASON: "Motivo",
    INVOICE_LINE_ITEMS_TITLE: "Posiciones del pedido",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Notas de crédito en posiciones del pedido",
    OTHER_CREDIT_NOTES: "Ajuste del pedido",
    REFUND_SHIPPING_COST: "gastos de envío de devolución",
    REFUND_HAS_BEEN_PAID: "Se ha reembolsado un monto de $VALUE.",
    REFUND_HAS_BEEN_PAID_FAILED: "Ocurrió un error al reembolsar un monto de $VALUE.",
    DOCUMENTS_FOR_ORDER: "Documentos del pedido",
    NO_INVOICES: "Aún no hay facturas disponibles",
    NO_CREDIT_NOTES: "Aún no hay notas de crédito disponibles",
    DOCUMENTS_ARE_GENERATING: "Los documentos de la factura se están generando. Por favor, inténtelo de nuevo en unos minutos.",
    INVALID_REQUEST_PATHWAY_SUPPORT: "No se pudieron encontrar documentos para este pedido. Por favor, contacte a support@pathway-solutions.de",
    INVALID_REQUEST_GENERIC: "No se pudieron encontrar documentos para este pedido. Por favor, contacte al comerciante correspondiente.",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT: "No se pudieron encontrar documentos para este pedido. Por favor, contacte a ${MAIL}.",
    GIFT_CARD_LINE: "Se utilizó un código de tarjeta de regalo ${GIFT_CARD_CODE} por ${GIFT_CARD_AMOUNT} para este pedido.",
    GIFT_CARD: "Tarjeta de regalo",
    REVERSAL_INVOICE: "Factura de anulación",
    DUTY: "Derechos de aduana",
    USED_DISCOUNTS: "Descuentos aplicados",
    PAYMENT_AT: "Pago el $DATE",
    REFUNDED_CREDITNOTE_AT: "Reembolso de la nota de crédito $CREDIT_NOTE el $DATE",
    REFUNDED_AT: "Reembolso el $DATE",
    PROCESSING_DOCUMENT: "Documento en proceso",
    DOWNLOAD_DOCUMENTS_TITLE: "¡Descarga tus documentos aquí!",
    MAIL_INTRODUCTION: "Para cualquier pregunta, póngase en contacto con ${MAIL}",
    REPAYMENT_DIFFERENCE: "Diferencia de reembolso",
    DOCUMENT_PREVIEW_BANNER: "Vista previa – por favor descargue el PDF",
};
